import { UrlInfo } from "./UrlInfo";
export abstract class AbstractViewMiddleware {
    public abstract intercept(from: UrlInfo | undefined, to: UrlInfo): Promise<Partial<UrlInfo> | undefined>;
}
